import * as React from 'react';
import { HiOutlinePencil } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';
import { Button, Text, Flex, Icon, Center } from '@chakra-ui/react';
import { Card } from 'components';

export const QuestionCard: React.FC<{
  title: string;
  description?: string;
  canEdit?: boolean;
  id?: string;
}> = ({ title, description, canEdit, id }) => {
  const navigate = useNavigate();
  return (
    <Card
      borderRadius="16px"
      minW={0}
      w={{ base: '100%', md: '368px' }}
      px="24px"
      py="32px"
    >
      <Flex>
        <Text
          lineHeight="24px"
          mt="-2px"
          fontSize="18px"
          fontWeight={600}
          color="text.100"
          textAlign="left"
        >
          {title}
        </Text>
        {canEdit && (
          <Center
            onClick={() =>
              id && navigate(`/centraldeduvidas/pergunta/editar/${id}`)
            }
            as="button"
            _hover={{ bg: 'grey.300' }}
            ml="12px"
            borderRadius="4px"
            minW="36px"
            h="36px"
            border="1px solid"
            borderColor="gray.100"
          >
            <Icon w="20px" h="20px" color="black" as={HiOutlinePencil} />
          </Center>
        )}
      </Flex>

      <Text textAlign="left" mb="24px" mt="8px" noOfLines={2} color="text.200">
        {description}
      </Text>
      <Button
        onClick={() =>
          id && navigate(`/centraldeduvidas/pergunta/${title.trim()}/${id}`)
        }
        border="1px"
        fontWeight="400"
        mt="auto"
        w={{ md: '132px', base: '100%' }}
      >
        Conheça mais
      </Button>
    </Card>
  );
};
